export default {
  cancelText: 'Cancel'
}



// WEBPACK FOOTER //
// ./src/components/search-bar/locale/en_US.js